function strCompare(a, b) {
  return (a !== undefined && b !== undefined) ? a.localeCompare(b) : 0;
}

function iso8601DateCompare(a, b) {
  return (a !== undefined && b !== undefined) ? new Date(a).getTime() - new Date(b).getTime() : 0;
}

function numCompare(a, b) {
  return (a !== undefined && b !== undefined) ? a - b : 0;
}

function sort(items, columnName, sortOrder) {
  const isAsc = sortOrder === 'ascending';

  return items.sort(function (va, vb) {
    const a = isAsc ? va : vb;
    const b = isAsc ? vb : va;

    if (columnName === 'displayName') {
      return strCompare(a.displayName, b.displayName);
    } else if (columnName === 'size') {
      return numCompare(a.size, b.size);
    } else if (columnName === 'lastVersion') {
      return iso8601DateCompare(a.backUpDate, b.backUpDate);
    } else if (columnName === 'path') {
      return strCompare(a.id, b.id);
    } else if (columnName === 'boxDisplayName') {
      return strCompare(a.boxDisplayName, b.boxDisplayName);
    } else if (columnName === 'days') {
      return numCompare(a.linkAgeDays, b.linkAgeDays);
    } else if (columnName === 'downloads') {
      return numCompare(a.hitCount, b.hitCount);
    } else if (columnName === 'creationDate') {
      return iso8601DateCompare(a.creationDate, b.creationDate);
    }

    console.log('Undefined table column name:', `'${columnName}'`);
    return 0;
  });
}

function contentSort(items, columnName, sortOrder) {
  if (items === undefined || items === null || items.length === 0) {
    return items;
  }

  const folders = items.filter(i => i.folderItem === true);
  const files = items.filter(i => i.folderItem !== true);

  const result = [];
  Array.prototype.push.apply(result, sort(folders, columnName, sortOrder));
  Array.prototype.push.apply(result, sort(files, columnName, sortOrder));

  return result;
}

export default contentSort;
